// Host photos provided by Manuel (Dec 2025).
export const HOST_PHOTO_1 =
  "https://customer-assets.emergentagent.com/job_prove-your-point/artifacts/3p6gv2cs_bm8i9498-edit.png";
export const HOST_PHOTO_2 =
  "https://customer-assets.emergentagent.com/job_prove-your-point/artifacts/qb1iuvoi_bm8i9365-edit.png";

// Brand palette — matches the cover artwork's red ♀ / blue ♂ duality.
export const BRAND = {
  red: "#E10600",
  blue: "#1E6FE0",
  black: "#0A0A0A",
  white: "#FFFFFF",
};

// Cities where the show is based & films
export const LOCATIONS = ["New York City", "Boston"];

// Merch store (Printful) — replace with the live store URL when ready.
export const MERCH_URL = "https://proveyourpointpodcast.printful.me";

export const SOCIALS = {
  instagram: "https://instagram.com/theproveyourpointpodcast",
  facebook: "https://facebook.com/proveyourpointpodcast",
  youtube: "https://youtube.com/@theproveyourpointpodcast",
  tiktok: "https://tiktok.com/@proveyourpointpodcast",
  email: "theproveyourpointpodcast@gmail.com",
  host_instagram: "https://instagram.com/iammanuelsantana",
  imdb: "https://www.imdb.com/title/tt43306414",
};

export const PODCAST_INFO = {
  name: "Prove Your Point Podcast",
  tagline:
    "Unfiltered conversations on relationships, intersexual dynamics & modern love.",
  subtagline:
    "What men think. What women feel. What nobody else will say out loud.",
  host: "Manuel Santana",
  schedule: "Live Mondays · 7PM – 9PM EST",
  season: "Season 2",
  premiere: "June 22",
};

// Topics that get covered on the show.
export const TOPICS = [
  "Dating",
  "Marriage",
  "Masculine Polarity",
  "Feminine Energy",
  "Modern Relationships",
  "Fatherhood",
  "Hookup Culture",
  "Loyalty",
];

// Platforms where listeners can subscribe.
export const PLATFORMS = [
  {
    name: "Spotify",
    handle: "Prove Your Point Podcast",
    url: "https://open.spotify.com/show/033rgTfiTjLGPaTefyE3OA",
    color: "#1DB954",
  },
  {
    name: "Apple Podcasts",
    handle: "Prove Your Point Podcast",
    url: "https://podcasts.apple.com/us/podcast/prove-your-point-podcast/id1896911048",
    color: "#A855F7",
  },
  {
    name: "YouTube Music",
    handle: "Prove Your Point Podcast",
    url: "https://music.youtube.com/playlist?list=OLSrHAmrIcS_Q57SjoVSd8DZvi1m9ymhB5A",
    color: "#FF0000",
  },
  {
    name: "iHeartRadio",
    handle: "Prove Your Point Podcast",
    url: "https://www.iheart.com/podcast/269-prove-your-point-podcast-336541374/",
    color: "#C6002B",
  },
  {
    name: "Amazon Music",
    handle: "Prove Your Point Podcast",
    url: "https://music.amazon.com/podcasts/653067bc-2908-4491-9021-7e97017495d4/prove-your-point-podcast",
    color: "#00A8E1",
  },
];

// Guest quotes / testimonials — populated as real guests come through.
export const GUEST_QUOTES = [];

export const STATS = [];

export const SPONSOR_TIERS = [
  {
    name: "Episode Drop",
    price: "From $1,500",
    accent: "red",
    features: [
      "60-second host-read mid-roll",
      "Logo on episode thumbnail",
      "1 social cross-promo (IG + TikTok)",
      "Mention in episode show notes",
    ],
  },
  {
    name: "Season Partner",
    price: "From $12,000",
    accent: "red",
    featured: true,
    features: [
      "Presenting sponsor on 8 episodes",
      "Custom intro tag on every drop",
      "Featured segment integration",
      "Logo on all marketing assets",
      "4 dedicated social posts",
    ],
  },
  {
    name: "Brand Takeover",
    price: "Custom",
    accent: "blue",
    features: [
      "Branded mini-series",
      "Co-created content & cross-promotion",
      "On-set product placement",
      "Behind-the-scenes content rights",
      "Quarterly strategy sessions",
    ],
  },
];
